import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ModalResponsavelComponent } from '../../modal-responsavel/modal-responsavel.component';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ProgramaService } from '../../services/programa.service';

@Component({
  selector: 'app-programa-agregador-list',
  templateUrl: './programa-agregador-list.component.html',
  styleUrls: ['./programa-agregador-list.component.scss']
})
export class ProgramaAgregadorListComponent extends BaseListComponent<any> implements OnInit, OnDestroy {

  lista: any;
  infoProjeto: ProjetoCadastro;
  idPrograma: number;

  @ViewChild("modalResonsavel") modalResonsavel: ModalResponsavelComponent;

  constructor(
    public activatedRoute: ActivatedRoute,
    public myservice: ProgramaService,
    private toastr: ToastrService,
  ) {
    super();
  }

  ngOnInit() {
    this.idPrograma = this.activatedRoute.snapshot.parent.params?.idProjeto;
    this.search();
  }

  search() {
    this.loading();
    let filtro = { filter_pg_id: this.idPrograma };
    this.addSub(
      this.myservice.getListSearchAgregadores(filtro).subscribe({
        next: (res) => {
          this.lista = res;
          this.loaded();
        },
        error: (error) => {
          this.toastr.error(error.error.message);
          this.loaded();
        },
      })
    );
  }

  editarClickHandler(data: any) {
    return ["/projetos/agregador/" + data.id + "/cadastro"];
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  viewResonsavel(programa: any) {
    this.modalResonsavel.openModal([programa, ...programa?.manager_adjunct]);
  }
}
